import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import {
  AngularFirestore,
  DocumentReference,
  AngularFirestoreCollection,
} from "@angular/fire/firestore";
import { Student } from "../models/student";
import { StudentViewModel } from "../models/student-view-model";
import { map, switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class StudentService {
  constructor(private db: AngularFirestore) { }

  private studentCollectionName = "student";
  public student: Student;
  public studentList: any;

  private cacheKey = 'studentCache_M'; // Clave para almacenar la caché en LocalStorage
  private cacheTimestampKey = 'studentCacheTimestamp_M'; // Clave para la marca de tiempo en LocalStorage
  private cacheDuration: number = 1800000; // Duración de la caché en milisegundos (por ejemplo, 1 minuto) 1min 60000

  lastStudentCollection = {};
  firstStudentCollection = {};

  currentYearCount= 0
  currentYear= this.getCurrentYear()
  currentYearSubject = new BehaviorSubject<number>(this.getCurrentYear());
  currentYear$ = this.currentYearSubject.asObservable()

 

  documentToDomainObject = (_) => {
    const object = _.payload.doc.data() as Student;
    const id = _.payload.doc.id;
    const doc = _.payload.doc;
    return {
      id,
      ...object,
      doc
    };
  };

  getStudent() {
 

    // const currentTime = Date.now();
    // const cachedTimestamp = parseInt(localStorage.getItem(this.cacheTimestampKey) || '0', 10);
    // if (currentTime - cachedTimestamp < this.cacheDuration) {
    //   const cachedData = JSON.parse(localStorage.getItem(this.cacheKey) || '[]');
    //   console.log("Utilizando cache")
    //   return of(cachedData);
    // }

    this.studentList = this.db
      .collection(this.studentCollectionName, (ref) =>
        ref.orderBy("createDate", "desc").limit(12)
      )
      .snapshotChanges()
      .pipe(map((actions) => actions.map(this.documentToDomainObject)));
    // localStorage.setItem(this.cacheKey, JSON.stringify(this.studentList));
    // localStorage.setItem(this.cacheTimestampKey, currentTime.toString());
    // console.log("consultando firebase")

    return this.studentList;
  }

  getStudentList(campus: string): Observable<Student[]> {
    switch (typeof campus) {
      case 'undefined':
        return of([])
      case 'string':
        if (campus != 'all') {
          return  this.db
            .collection(this.studentCollectionName, (ref) =>
              ref.orderBy("createDate", "desc").where('campus', '==', campus).where('createDate','>=',new Date(this.getCurrentYearNext()-1,11,31)).where('createDate','<=',new Date(this.getCurrentYearNext()+1,0,1)).orderBy('campus', 'asc')
            )
            .snapshotChanges()
            .pipe(map((actions) => actions.map(this.documentToDomainObject)),
              switchMap((student) => {
                return of(student)
              }));
        }else{
          return  this.db
            .collection(this.studentCollectionName, (ref) =>
              ref.orderBy("createDate", "desc").where('createDate','>=',new Date(this.getCurrentYearNext()-1,11,31)).where('createDate','<=',new Date(this.getCurrentYearNext()+1,0,1))
            )
            .snapshotChanges()
            .pipe(map((actions) => actions.map(this.documentToDomainObject)),
              switchMap((student) => {
                return of(student)
              }));
        }

    }
  }

   

  getStudentByFilter(campus: string, carrera: string, turno: string) {
    if (campus != "all" && carrera == "all" && turno != "all") {
      this.studentList = this.db
        .collection(this.studentCollectionName, (ref) =>
          ref.where("campus", "==", campus).where("turn", "==", turno)
        )
        .snapshotChanges()
        .pipe(map((actions) => actions.map(this.documentToDomainObject)));
    }
    if (campus == "all" && carrera != "all" && turno == "all") {
      this.studentList = this.db
        .collection(this.studentCollectionName, (ref) =>
          ref.where("carrera", "==", carrera)
        )
        .snapshotChanges()
        .pipe(map((actions) => actions.map(this.documentToDomainObject)));
    }
    if (campus == "all" && carrera != "all" && turno != "all") {
      this.studentList = this.db
        .collection(this.studentCollectionName, (ref) =>
          ref.where("turn", "==", turno).where("carrera", "==", carrera)
        )
        .snapshotChanges()
        .pipe(map((actions) => actions.map(this.documentToDomainObject)));
    }
    if (campus == "all" && carrera == "all" && turno == "all") {
      this.studentList = this.db
        .collection(this.studentCollectionName, (ref) =>
          ref.orderBy("createDate", "desc")
        )
        .snapshotChanges()
        .pipe(map((actions) => actions.map(this.documentToDomainObject)));
    } else if (campus != "all" && carrera == "all" && turno == "all") {
      this.studentList = this.db
        .collection(this.studentCollectionName, (ref) =>
          ref.where("campus", "==", campus)
        )
        .snapshotChanges()
        .pipe(map((actions) => actions.map(this.documentToDomainObject)));
    } else if (campus != "all" && carrera != "all" && turno == "all") {
      this.studentList = this.db
        .collection(this.studentCollectionName, (ref) =>
          ref.where("campus", "==", campus).where("carrera", "==", carrera)
        )
        .snapshotChanges()
        .pipe(map((actions) => actions.map(this.documentToDomainObject)));
    } else if (campus != "all" && carrera != "all" && turno != "all") {
      this.studentList = this.db
        .collection(this.studentCollectionName, (ref) =>
          ref
            .where("campus", "==", campus)
            .where("carrera", "==", carrera)
            .where("turn", "==", turno)
        )
        .snapshotChanges()
        .pipe(map((actions) => actions.map(this.documentToDomainObject)));
    }

    return this.studentList;
  }
  // getAll(): Observable<firebase.firestore.QuerySnapshot> {
  //   return this.db
  //     .collection<Student>(this.studentCollectionName, (ref) =>
  //       ref.orderBy("createDate", "desc")
  //     )
  //     .get();
  // }


  saveStudent(student: Student): Promise<DocumentReference> {
    return this.db.collection(this.studentCollectionName).add(student);
  }
  editStudent(student: StudentViewModel): Promise<void> {
    return this.db
      .collection(this.studentCollectionName)
      .doc(student.id)
      .update(student);
  }
  editSavePartial(id: string, obj: Object) {
    return this.db.collection(this.studentCollectionName).doc(id).update(obj);
  }
  deleteStudent(idStudent: string): Promise<void> {
    return this.db
      .collection(this.studentCollectionName)
      .doc(idStudent)
      .delete();
  }

  getCurrentYear():number{
    const fechaActual = new Date();
    return fechaActual.getFullYear()
  }

  setCurrentYear(newYear:number){
    this.currentYearSubject.next(newYear)
    this.currentYear = newYear
  }

  getCurrentYearNext():number{
    return this.currentYearSubject.value
  }


}
